/* tslint:disable */

declare var Object: any;
export interface ViewAttReportInterface {
  "empId": string;
  "fullName"?: string;
  "shiftdailyCode": string;
  "shiftName"?: string;
  "attDate"?: Date;
  "shiftstarttime"?: string;
  "shiftendtime"?: string;
  "starttime"?: string;
  "endtime"?: string;
  "remark"?: string;
  "companyId": number;
  "attendId": string;
}

export class ViewAttReport implements ViewAttReportInterface {
  "empId": string;
  "fullName": string;
  "shiftdailyCode": string;
  "shiftName": string;
  "attDate": Date;
  "shiftstarttime": string;
  "shiftendtime": string;
  "starttime": string;
  "endtime": string;
  "remark": string;
  "companyId": number;
  "attendId": string;
  constructor(data?: ViewAttReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewAttReport`.
   */
  public static getModelName() {
    return "ViewAttReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewAttReport for dynamic purposes.
  **/
  public static factory(data: ViewAttReportInterface): ViewAttReport{
    return new ViewAttReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewAttReport',
      plural: 'ViewAttReports',
      path: 'ViewAttReports',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "shiftdailyCode": {
          name: 'shiftdailyCode',
          type: 'string'
        },
        "shiftName": {
          name: 'shiftName',
          type: 'string'
        },
        "attDate": {
          name: 'attDate',
          type: 'Date'
        },
        "shiftstarttime": {
          name: 'shiftstarttime',
          type: 'string'
        },
        "shiftendtime": {
          name: 'shiftendtime',
          type: 'string'
        },
        "starttime": {
          name: 'starttime',
          type: 'string'
        },
        "endtime": {
          name: 'endtime',
          type: 'string'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "attendId": {
          name: 'attendId',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewAttReport.ts